import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Installation } from 'config'

import { AccessWizard as AccessWizard23 } from 'projects/flow-gui-access/views/2.3/access'
import { AccessWizard as AccessWizard24 } from 'projects/flow-gui-access/views/2.4/access'

class AccessWizard extends Component {

  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.4').length !== 0) {
      return <AccessWizard24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.3').length !== 0) {
      return <AccessWizard23 {...this.props} />
    } else return false
  }
}
//eslint-disable-next-line
AccessWizard = connect(state => state)(AccessWizard)
export default AccessWizard



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/access/wizard.js